var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { formatInTimeZone, fromZonedTime } from 'date-fns-tz';
export var sqlWorkdayToDateKey = function (workday) {
    return formatInTimeZone(workday, 'UTC', 'yyyy-MM-dd');
};
export var medianOfNumbers = function (values) {
    var finite = values.filter(function (v) { return Number.isFinite(v); });
    if (!finite.length)
        return null;
    var sorted = __spreadArray([], finite, true).sort(function (a, b) { return a - b; });
    var mid = Math.floor(sorted.length / 2);
    if (sorted.length % 2 === 1)
        return sorted[mid];
    return (sorted[mid - 1] + sorted[mid]) / 2;
};
export var activityMinutesOfDay = function (date, timeZoneIana) {
    if (Number.isNaN(date.getTime()))
        return NaN;
    if (timeZoneIana) {
        var wallClock = formatInTimeZone(date, timeZoneIana, 'HH mm');
        var _a = wallClock.split(' ').map(function (n) { return parseInt(n, 10); }), h = _a[0], m = _a[1];
        return h * 60 + m;
    }
    return date.getHours() * 60 + date.getMinutes();
};
var minutesOfDayToTimeString = function (totalMinutes) {
    if (!Number.isFinite(totalMinutes))
        return null;
    var rounded = Math.round(totalMinutes);
    var hours = Math.floor(rounded / 60);
    var minutes = rounded % 60;
    return "".concat(hours.toString().padStart(2, '0'), ":").concat(minutes
        .toString()
        .padStart(2, '0'), ":00");
};
export var medianTime = function (activities, type, timeZoneIana) {
    var validActivities = activities.filter(Boolean);
    if (!validActivities.length)
        return null;
    var minutes = validActivities.map(function (item) {
        var date = type === 'start' ? item.firstActivity : item.lastActivity;
        return activityMinutesOfDay(date, timeZoneIana);
    });
    var medianMinutes = medianOfNumbers(minutes);
    if (medianMinutes === null)
        return null;
    return minutesOfDayToTimeString(medianMinutes);
};
var wallClockTimeToUtcDate = function (workdayDate, time, timeZoneIana) {
    if (!time)
        return null;
    var _a = time.split(':').map(function (part) { return parseInt(part, 10); }), hours = _a[0], minutes = _a[1];
    if (!Number.isFinite(hours) || !Number.isFinite(minutes))
        return null;
    return fromZonedTime("".concat(workdayDate, "T").concat(hours.toString().padStart(2, '0'), ":").concat(minutes
        .toString()
        .padStart(2, '0'), ":00"), timeZoneIana);
};
export var computeMedianTeamBoundsForDay = function (members, workdayDate, timeZoneIana) {
    if (!members.length)
        return null;
    var _a = ensureValidWorkdayTimeRange(medianTime(members, 'start', timeZoneIana), medianTime(members, 'end', timeZoneIana)), startTime = _a.startTime, endTime = _a.endTime;
    var firstActivity = wallClockTimeToUtcDate(workdayDate, startTime, timeZoneIana);
    var lastActivity = wallClockTimeToUtcDate(workdayDate, endTime, timeZoneIana);
    if (!firstActivity || !lastActivity)
        return null;
    return { firstActivity: firstActivity, lastActivity: lastActivity };
};
export var ensureValidWorkdayTimeRange = function (startTime, endTime) {
    if (!startTime || !endTime)
        return { startTime: startTime, endTime: endTime };
    return endTime < startTime
        ? { startTime: startTime, endTime: startTime }
        : { startTime: startTime, endTime: endTime };
};
